module.exports = __webpack_public_path__ + "img/question17c1.cdc80d03.png";